
// This is an auto generated file - do not edit!
// Swagger path: /api/AmlRisk/export

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import {
    Export
} from '@wdx/clmi/clmi-swagger-gen';

@Injectable({ providedIn: 'root' })
export class AmlriskExportApiService extends BaseApiService {
    
    post(_export: any, options = {}): Observable<Export> {
        return this._post<Export, any>(
            `/AmlRisk/export`,
            _export,
            options
        );
    }
}
